import React, { useState, useRef, useEffect } from 'react';
import { useTheme } from './ThemeContext';

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const themeOptions = [
    { value: 'light', label: 'Light', icon: 'fas fa-sun' },
    { value: 'dark', label: 'Dark', icon: 'fas fa-moon' },
    { value: 'system', label: 'System', icon: 'fas fa-desktop' }
  ];

  const currentTheme = themeOptions.find(option => option.value === theme);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    setIsOpen(false);
  };

  return (
    <div className="theme-toggle dropdown" ref={dropdownRef}>
      <button 
        className="btn-icon theme-toggle-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        title="Change theme"
      >
        <i className={currentTheme.icon}></i>
      </button>

      <ul className={`dropdown-menu dropdown-menu-end ${isOpen ? 'show' : ''}`}>
        {themeOptions.map((option) => (
          <li key={option.value}>
            <button
              className={`dropdown-item ${theme === option.value ? 'active' : ''}`}
              onClick={() => handleThemeChange(option.value)}
            >
              <i className={`${option.icon} me-2`}></i>
              {option.label}
              {theme === option.value && (
                <i className="fas fa-check ms-auto"></i>
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ThemeToggle;